/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */
export const PAYMENT_ADD_REQUEST = 'INVOICE_PAYMENT_REQUEST';
export const PAYMENT_ADD_REQUEST_SUCCESS = 'INVOICE_PAYMENT_REQUEST_SUCCESS';
export const PAYMENT_ADD_REQUEST_FAILURE = 'INVOICE_PAYMENT_REQUEST_FAILURE';

export const PAYMENT_PARTNERS_LIST_REQUEST = 'PAYMENT_PARTNER_LIST_REQUEST';
export const PAYMENT_PARTNERS_LIST_REQUEST_SUCCESS = 'PAYMENT_PARTNER_LIST_REQUEST_SUCCESS';
export const PAYMENT_PARTNERS_LIST_REQUEST_FAILURE = 'PAYMENT_PARTNER_LIST_REQUEST_FAILURE';

export const PAYMENT_PARTNER_SECRET_REQUEST = 'PAYMENT_PARTNER_SECRET_REQUEST';
export const PAYMENT_PARTNER_SECRET_REQUEST_SUCCESS = 'PAYMENT_PARTNER_SECRET_REQUEST_SUCCESS';
export const PAYMENT_PARTNER_SECRET_REQUEST_FAILURE = 'PAYMENT_PARTNER_SECRET_REQUEST_FAILURE';

export const PAYMENTS_LIST_FETCH_REQUEST = 'PAYMENTS_LIST_FETCH_REQUEST';
export const PAYMENTS_LIST_FETCH_REQUEST_SUCCESS = 'PAYMENTS_LIST_FETCH_REQUEST_SUCCESS';
export const PAYMENTS_LIST_FETCH_REQUEST_FAILURE = 'PAYMENTS_LIST_FETCH_REQUEST_FAILURE';

export const PAYMENT_MODE_FETCH_REQUEST = 'PAYMENT_MODE_FETCH_REQUEST';
export const PAYMENT_MODE_FETCH_REQUEST_SUCCESS = 'PAYMENT_MODE_FETCH_REQUEST_SUCCESS';
export const PAYMENT_MODE_FETCH_REQUEST_FAILURE = 'PAYMENT_MODE_FETCH_REQUEST_FAILURE';

export const CLEAN_PAYMENTS_PROPS = 'CLEAN_PAYMENTS_PROPS';
export const CLEAN_PAYMENTS_LIST_PROPS = 'CLEAN_PAYMENTS_LIST_PROPS';

export const BANK_ACCOUNT_TYPE_FETCH_REQUEST = 'BANK_ACCOUNT_TYPE_FETCH_REQUEST';
export const BANK_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS = 'BANK_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS';
export const BANK_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE = 'BANK_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE';

export const PAYMENT_MODE_FILTER_FETCH_REQUEST = 'PAYMENT_MODE_FILTER_FETCH_REQUEST';
export const PAYMENT_MODE_FILTER_FETCH_REQUEST_SUCCESS =
  'PAYMENT_MODE_FILTER_FETCH_REQUEST_SUCCESS';
export const PAYMENT_MODE_FILTER_FETCH_REQUEST_FAILURE =
  'PAYMENT_MODE_FILTER_FETCH_REQUEST_FAILURE';

export const SINGLE_PAYMENT_FETCH_REQUEST = 'SINGLE_PAYMENT_FETCH_REQUEST';
export const SINGLE_PAYMENT_FETCH_REQUEST_SUCCESS = 'SINGLE_PAYMENT_FETCH_REQUEST_SUCCESS';
export const SINGLE_PAYMENT_FETCH_REQUEST_FAILURE = 'SINGLE_PAYMENT_FETCH_REQUEST_FAILURE';

export const CLEAN_SINGLE_PAYMENT_PROPS = 'CLEAN_SINGLE_PAYMENT_PROPS';

export const SAVE_PAYMENT_ERROR_MESSAGE_REQUEST = 'SAVE_PAYMENT_ERROR_MESSAGE_REQUEST';
export const SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_SUCCESS =
  'SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_SUCCESS';
export const SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_FAILURE =
  'SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_FAILURE';
